module.exports = __webpack_public_path__ + "img/Shayofae google analytics.8b099f33.png";